module.exports = __webpack_public_path__ + "static/media/rightSideTag.7c8ccefe.svg";